import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { finalize } from 'rxjs';

import { Addon, Agreement } from '../schemas';
import { AgreementService, Messenger } from '../service';

export interface UpdateNextInvoiceDateData {
  agreement: Agreement;
  addon?: Addon;
}

@Component({
  selector: 'lcm-update-invoice-date-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogModule, MatButtonModule, MatProgressBarModule],
  template: `
    <h2 mat-dialog-title>Update invoice date</h2>
    <mat-dialog-content> Please confirm that the client has been invoiced. </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button matButton mat-dialog-close [disabled]="pending()">Cancel</button>
      <button matButton [disabled]="pending()" (click)="save()">Confirm</button>
    </mat-dialog-actions>

    @if (pending()) {
      <mat-progress-bar mode="indeterminate" />
    }
  `,
  styles: ``,
})
export class UpdateInvoiceDateDialog {
  data = inject(MAT_DIALOG_DATA) as UpdateNextInvoiceDateData;
  hostDialog = inject(MatDialogRef);
  messenger = inject(Messenger);

  agreements = inject(AgreementService);
  pending = signal(false);

  save() {
    this.pending.set(true);
    const { agreement, addon } = this.data;

    this.agreements
      .updateNextInvoiceDate(agreement.AgreementNumber, addon?.Id)
      .pipe(finalize(() => this.pending.set(false)))
      .subscribe({
        next: () => this.hostDialog.close(true),
        error: this.messenger.handleHttpError,
      });
  }
}
